module.exports = __webpack_public_path__ + "img/home-bg.6a55bee2.png";